'use strict'

import HttpClient from './HttpClient'

class File extends HttpClient {
  urls = {}
  constructor (type = '', refId = '') {
    super()
    if (refId) {
      refId = '/' + refId
    }
    const apiUrl = {
      quoteDoc: {
        all: '/api/admin/quote/doc/all' + refId,
        getOne: '/api/admin/quote/download/doc'
      }
    }
    switch (type) {
      case 'quote-doc':
        this.urls = apiUrl.quoteDoc
        break
      default:
        alert('ระบุเอกสารผิดพลาด')
    }
  }
  getUploadUrl () {
    return process.env.VUE_APP_LOGISTY_API_HOST_NAME + this.urls.upload
  }
  deleteDoc (docId) {
    var url = this.urls.delete

    var data = {
      docId: docId
    }

    return this.sendDelete(url, this.headers, data)
  }
  getAllDoc () {
    var url = this.urls.all
    return this.sendGet(url, this.headers)
  }
  downloadFile (fileId) {
    var url = this.urls.getOne + '/' + fileId
    return this.sendGetFile(url, this.headers)
  }
}

export default File
